import { z } from 'zod';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { t } from '@/i18n';

export const updateRegistrationDataFormSchema = z.object({
  name: z.string().min(1, t('pages.profile.components.profile_registration_data_tab_content.schema.required')),
  document: z
    .string()
    .min(1, t('pages.profile.components.profile_registration_data_tab_content.schema.required'))
    .refine(value => {
      return cpf.isValid(value) || cnpj.isValid(value);
    }, t('pages.profile.components.profile_registration_data_tab_content.schema.required_document')),
  phone: z.string().min(1, t('pages.profile.components.profile_registration_data_tab_content.schema.required')),
});

export type UpdateRegistrationDataFormData = z.infer<typeof updateRegistrationDataFormSchema>;
